import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { DataService } from 'src/app/shared/data.service';
import { AddProductComponent } from '../add-product/add-product.component';

@Component({
    selector: 'app-requested-product-details',
    templateUrl: './requested-product-details.component.html',
    styleUrls: ['./requested-product-details.component.scss'],
    standalone: false
})
export class RequestedProductDetailsComponent implements OnInit {
  product: any;
  productName: any;

  constructor(public dialogRef: MatDialogRef<RequestedProductDetailsComponent>,
    private dataService: DataService,
    private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
      this.product = data.product;
      this.productName = data.productName;
    }
  
  ngOnInit(): void {
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  Approve() {
    if (this.product.type === 2) {
      const dialogRef = this.dialog.open(AddProductComponent,
        {disableClose: true, width: '600px', data: {product: {name: this.product.productName}}
      });
      dialogRef.afterClosed().subscribe((status) => {
        this.approveProduct(status.id)
      });
    } else {
      this.approveProduct(this.product.productId)
    }
  }

  Reject() {
    const payload = {
      ProductAccessRequestId: this.product.id
    };
    this.dataService.post('ProductAccessRequest/DeniedProductAccessRequest', payload).then((data) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Product rejected successfuly!',
            buttonText: 'Ok'
          }
        });
      }
      else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

  approveProduct(productId: any) {
    const payload = {
      ProductId: productId,
      ProductAccessRequestId: this.product.id
    };
    this.dataService.post('ProductAccessRequest/ApproveProductAccessRequest', payload).then((data: any) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Product approved successfuly!',
            buttonText: 'Ok'
          }
        });
      }
      else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

}
